export function incidentTableColumnProps(columnKey: string) {
  return {
    onHeaderCell: () => ({
      className: `incident-col incident-col--${columnKey}`,
    }),
    onCell: () => ({
      className: `incident-col incident-col--${columnKey}`,
    }),
  };
}
